'use client'

import { useEffect } from 'react'

import { ThemeLabPanel } from './theme-lab-panel'
import { useIsClient } from './use-is-client'
import { useThemeLabStore } from './use-theme-lab-store'

const isDev = process.env.NODE_ENV !== 'production'

export function ThemeLabMount() {
  const isClient = useIsClient()
  const toggleOpen = useThemeLabStore((s) => s.toggleOpen)

  useEffect(() => {
    if (!isDev) return

    function applyPersistedTokens(): void {
      useThemeLabStore.getState().apply()
    }

    if (useThemeLabStore.persist.hasHydrated()) {
      applyPersistedTokens()
    } else {
      return useThemeLabStore.persist.onFinishHydration(applyPersistedTokens)
    }
  }, [])

  useEffect(() => {
    if (!isDev) return

    function handleKeyDown(event: KeyboardEvent): void {
      if (
        (event.metaKey || event.ctrlKey) &&
        event.shiftKey &&
        event.key.toLowerCase() === 'l'
      ) {
        event.preventDefault()
        toggleOpen()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [toggleOpen])

  if (!isDev || !isClient) return null

  return <ThemeLabPanel />
}
